/**
 * Card Component
 * 
 * Data display component for grouped content.
 * Uses design tokens only, no inline styles.
 */

import type { ReactNode } from 'react';

export interface CardProps {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className = '' }: CardProps) {
  const baseClasses = [
    'bg-[var(--surface-bg-panel)]',
    'border',
    'border-[var(--surface-border-subtle)]',
    'rounded-[var(--radius-xl)]',
    'p-[var(--space-6)]',
    'shadow-[var(--shadow-md)]',
  ].join(' ');

  const classes = `${baseClasses} ${className}`.trim();

  return <div className={classes}>{children}</div>;
}
